var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 14.625,
    transform: "rotate(-90 19.5 19.5)",
    fill: "#8276F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2861 20.8764C13.4694 21.0356 13.718 21.125 13.9771 21.125C14.2363 21.125 14.4848 21.0356 14.6681 20.8764L19.5059 16.6742L24.3437 20.8764C24.528 21.0311 24.7749 21.1167 25.0312 21.1147C25.2874 21.1128 25.5325 21.0235 25.7137 20.8661C25.895 20.7087 25.9977 20.4958 26 20.2732C26.0022 20.0506 25.9037 19.8361 25.7257 19.676L20.1969 14.8736C20.0136 14.7144 19.7651 14.625 19.5059 14.625C19.2467 14.625 18.9982 14.7144 18.8149 14.8736L13.2861 19.676C13.1029 19.8352 13 20.0511 13 20.2762C13 20.5013 13.1029 20.7172 13.2861 20.8764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.f1c1e731c6ddfe39de8b57534931a84a.svg";
export { ForwardRef as ReactComponent };